import React from 'react';
import Arrow from '../../../assets/svg/shadow-arrow.svg?react';
import classNames from 'classnames';
import styles from './FJPopupMenuArrow.module.less';

const FJPopupMenuArrow = props => {
    const { className, style } = props;
    return <Arrow className={classNames(styles.arrow, className)} style={style} />;
};

export default FJPopupMenuArrow;
